import * as THREE from "three";
import Instruction from "./fw/instruction";
import Globe from "./globe";

export default class WorldScreen extends Instruction {
    constructor () {
        super();

        this.name = "WorldScreen";

        this.globe = new Globe();

        this.attach(this.globe);

        Object.assign(this.s, {
            cameraFOV : 90,
            rotation : 0.1
        });
    }
    
    setup () {
        var gw = this.parent.a.gamewindow;

        this.a.scene = new THREE.Scene();

        var aspect = gw.s.width/gw.s.height;
        this.a.camera = new THREE.PerspectiveCamera(this.s.cameraFOV/aspect, aspect, 0.01, 10);
        this.a.camera.translateZ(4);

        this.a.scene.add(this.globe.a.scene);

        this.a.light = new THREE.PointLight(0xffffff, 1, 100, 0.01);
        this.a.light.position.set(3, 0, 3);
        this.a.scene.add(this.a.light);

        var oldscene = gw.a.scene;
        var oldcamera = gw.a.camera;

        this.external(() => {
            gw.a.scene = this.a.scene;
            gw.a.camera = this.a.camera;
        }, () => {
            gw.a.scene = oldscene;
            gw.a.camera = oldcamera;
        });

        this.external(() => {
            this.parent.a.controller.registerOnChannel("rotate", this);
        }, () => {
            this.parent.a.controller.unsubscribe(this);
        });

        this.external(() => {
            this.game.addLogic({
                update: (delta, newtime) => {
                    var rotation = this.globe.a.scene.rotation;
                    rotation.set(0, rotation.y + delta/1000*this.s.rotation, 0);
                }
            }, "globerotate");
        }, () => {
            this.game.removeLogic("globerotate");
        });
    }

    receiveMessage (channel, message) {
        if (message == "anticlockwise") this.s.rotation = 1;
        else if (message == "clockwise") this.s.rotation = -1;
        else if (message == "stop") this.s.rotation = 0.1;
    }
}
